import AdminNavigation from 'components/admin/Navigation/AdminNavigation'
import ChangePassword from 'components/shared/Login/ChangePassword'
import ForgotPassword from 'components/shared/Login/ForgotPassword'
import Login from 'components/shared/Login/Login'
import Dashboard from 'containers/admin/dashboard'
import CustomerOrders from 'containers/admin/customer_orders'
import DealerOrders from 'containers/admin/dealer_orders'
import Products from 'containers/admin/products'
import Properties from 'containers/admin/properties'
import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import routes from 'redux/routes.yaml'
import { loadCurrentUser } from 'redux/user'
import ContactRequests from './containers/admin/contact_requests'
import DealerCompare from './containers/admin/dealer_compare'
import DealerImport from './containers/admin/dealer_import'
import Users from './containers/admin/users'
import Discounts from './containers/admin/discounts'
import ProductCategories from './containers/admin/product_categories'
import ProductCompare from './containers/admin/product_compare'
import ProductImport from './containers/admin/product_import'
import RoutesAdmin from './containers/admin/routes'
import Todos from './containers/admin/todos'

const ConnectedSwitch = connect((state) => ({ location: state.location }))(
  Switch
)

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      loadCurrentUser,
    },
    dispatch
  )
}

const components = {
  RoutesAdmin,
  Login,
  ForgotPassword,
  ChangePassword,
  AdminNavigation,
  Dashboard,
  Todos,
  Products,
  Properties,
  DealerOrders,
  CustomerOrders,
  ContactRequests,
  DealerCompare,
  DealerImport,
  Discounts,
  ProductCompare,
  ProductImport,
  Users,
  ProductCategories,
}

class Routes extends React.Component {
  componentWillMount() {
    const { loadCurrentUser } = this.props
    loadCurrentUser()
  }

  getRedirects() {
    const redirects = routes.filter((route) => route.redirect && !route.node)
    return redirects.map((redirect) => (
      <Route path={redirect.path} exact={redirect.exact}>
        <Redirect to={redirect.target} />
      </Route>
    ))
  }

  getRoutes(path) {
    let resultRoutes = routes
      .filter((route) => route.component)
      .map((route) => {
        let returnValue = undefined
        const { path, component, exact } = route
        if (typeof path === 'string') {
          returnValue = { path, component, exact }
        }
        return returnValue
      })
    resultRoutes = resultRoutes
      .reduce((a, b) => a.concat(b), [])
      .filter((route) => !!route) // flatten and remove undefined

    // if wanted only get child routes of given path
    // add trailing slash cause React Router always shows path without it
    if (path) {
      resultRoutes = resultRoutes.filter(
        (route) => route.path.indexOf(path.concat('/')) === 0
      )
    }
    //sort by path (important for switch, cause searches upwards down)
    resultRoutes = resultRoutes.sort((a, b) => a.path.localeCompare(b.path))
    // turn into real routes now, deserialiazing the component string (https://stackoverflow.com/a/6394168)
    return resultRoutes.map((route) => (
      <Route
        path={route.path}
        component={route.component
          .split('.')
          .reduce((o, i) => o[i], components)}
        exact={route.exact}
      />
    ))
  }

  getFallbackRoute() {
    if (!routes) return
    const fallbackDefinitionRoute = routes.find(
      (route) => route.node === '/fallback'
    )
    const fallbackRoute =
      fallbackDefinitionRoute &&
      routes.find((route) => route.node === fallbackDefinitionRoute.redirect)
    const fallbackPath = fallbackRoute && fallbackRoute.path
    if (!fallbackDefinitionRoute) {
      console.warn(
        'No fallback route found! Is /fallback set in database? routes:',
        routes
      )
    }
    if (!fallbackRoute) {
      console.warn(
        `No fallback route found! /fallback points to ${
          fallbackDefinitionRoute.redirect
        }, but path doesn't exist.`
      )
    }
    if (!fallbackPath) {
      console.warn('No fallback path found!')
    }
    return fallbackPath ? <Redirect to={fallbackPath} /> : false
  }

  render() {
    let returnValue = false
    const { path } = this.props
    if (path) {
      returnValue = <ConnectedSwitch children={this.getRoutes(path)} />
    } else {
      returnValue = (
        <ConnectedSwitch
          children={this.getRedirects().concat(
            this.getRoutes(),
            this.getFallbackRoute()
          )}
        />
      )
    }
    return returnValue
  }
}

Routes = connect(mapStateToProps, mapDispatchToProps)(Routes)
export default withRouter(Routes)



// WEBPACK FOOTER //
// ./src/Routes.jsx